export const HINTS_DISABLED_CACHE_KEY = "hintsDisabled";
export const HINTS_DISCLAIMER_DISABLED_CACHE_KEY = "hintsDisclaimerDisabled";
